import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { KycComponent } from "@mediassistrepo/kyc-component";


export default function NewKycWebComponent(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigation = (value: any) => {
    navigate(-1);
    if (value?.isSuccess) {
      props?.notify();
    }
  }
  const getClaimId = (value: any) => {
    if (value?.isSoftLoginRequired) {
      navigate(`/auth/${props?.claimId}`);
    }
  }
  return <KycComponent
    getClaimId={getClaimId}
    handleNavigation={handleNavigation}
    handleClickUpload={() => { }}
    handlekycEvents={() => { }}
    claimId={props?.claimId}
    maid={props?.maid ? props?.maid : localStorage.getItem("maid")}
    accessToken={localStorage.getItem("accessToken")}
    benefName={props?.benefName
      ? props?.benefName
      : localStorage.getItem("benefName")}
  />
}
